export default "__VITE_ASSET__C6J9Pj0p__"